import React from "react";
import {
    Arrow,
    Close,
    Live,
    Pause,
    Play,
    Selected,
    Settings,
    Share,
    Sound,
    SoundOff,
    History,
    DefaultGeoRestriction,
    DefaultUnavailable,
    DefaultThumbnail,
    Listeners,
    Integration,
    Copy,
    Facebook,
    X,
} from "../components/Icon";
import embed from "../front/img/embed.svg"
import facebook from "../front/img/facebook.svg"
import twitter from "../front/img/twitter.svg"
import Slider from "@mui/material/Slider";
import ReactPlayer from "react-player";
import {adjustColor, getContrastingColor, isColorClose, opacifyColor} from "./colorHelper"
import {Box, LinearProgress} from "@mui/material";
import Hls from "hls.js";
import {numberFragmentBeforeLive} from "../components/Player/Player";
import Link from "../components/Icon/Link";


const SMALLEST_BUFFER = 600;

export function WithoutLogoClassStyle(logo, initialClasses = "") {
    return logo ? initialClasses : initialClasses + " without-logo";
}

export function updatePlayerRatio(playerRatio, historyRatio) {
    // Define the ratio to adjust the size of the player in css because the history extended is added under the player
    document.body.style.setProperty('--ratio-player', playerRatio);
    // Define the ratio of history because we keep the same css used for overlay but display under the player
    document.body.style.setProperty('--ratio-history', historyRatio);
}

export function initPlayerColors(config) {
    document.body.style.setProperty("--button-color", config.buttonColor);
    document.body.style.setProperty("--scrollbar-color", config.buttonColor + '55'); // add 0.3 opacity to the buttonColor to get scrollbar color
    document.body.style.setProperty("--background-color", config.backgroundColor);
    document.body.style.setProperty("--secondary-color", config.secondaryColor);
}

const OnAirBlock = (props) => {
    const formatToTitleCase = (title) => {
        return title.replace(/\w\S*/g, function (splittedTitle) {
            return splittedTitle.charAt(0).toUpperCase() + splittedTitle.substring(1).toLowerCase();
        });
    }
    return (<div
        onClick={(event) => props.onChange(props.bufferSize - (props.fragment * numberFragmentBeforeLive), true)}
        id="on-air-block"
        style={props.previousPlayTime >= props.fragment * numberFragmentBeforeLive * -1 ?
            {'backgroundColor': props.secondaryColor, 'color': props.buttonColor}
            :
            {'backgroundColor': '#666666', 'color': props.buttonColor}
        }>
        <p id="on-air">{formatToTitleCase(props.onAirLabel)}</p>
    </div>)
}


export function Timeline(props) {
    const fragment = props.fragment ?? 5;
    const playlist = props.playlist ?? 5;
    const bufferSize = Math.min(props.bufferSize, fragment * playlist); // keep the min value between the real player buffer and the hls playlist size
    const max = bufferSize - (fragment * numberFragmentBeforeLive);
    const min = Math.min(max, fragment * numberFragmentBeforeLive);
    const toolTip = document.getElementById('timeline-tooltip');
    const timelineRange = document.getElementById('timeline-range');

    const convertValueToRange = (value, minInput, maxInput, minOutput, maxOutput) => {
        //équation de mise à l'échelle linéaire
        const linearScaling = ((value - minInput) * (maxOutput - minOutput) / (maxInput - minInput)) + minOutput
        if (linearScaling > maxOutput) return maxOutput;
        if (linearScaling < minOutput) return minOutput;
        return ~~linearScaling;
    }
    const formatTime = (time) => {
        const sign = time < 0 ? "-" : "";
        time = Math.abs(time);

        const hours = Math.floor(time / 3600);
        time %= 3600;
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };
    // @todo fix diplay timeline, need to visible more late
    let isVisible = !!bufferSize && (props.streamFormat === 'hls' && !props.neverPlayed && bufferSize >= SMALLEST_BUFFER && !props.isLoading) && (props.bufferPreviewed || (props.isDirectControl && !props.isHlsBuffered));
    return (
        <div
            className={`timeline-container ${isVisible ? 'shown' : 'hidden'}`}>
            { props.bufferPreviewed &&
                <LinearBuffer color={props.secondaryColor} player={props.player}
                    previousPlayTime={props.previousPlayTime}></LinearBuffer>
            }
            {
                isVisible && <>
                    <Slider className="timeline-container-slider" type='range' min={min}
                            max={max}
                            defaultValue={max}
                            value={props.previousPlayTime + max}
                            step={1}
                            id="timeline-range"
                            onChange={(event, value) => props.onChange(value, false)}
                            style={{color: props.buttonColor}}
                            onChangeCommitted={(event, value) => {
                                if (props.onChangeCommittedFlush && props.player?.getInternalPlayer('hls'))
                                    props.player.getInternalPlayer('hls').trigger(Hls.Events.BUFFER_FLUSHING, {
                                        startOffset: 0,
                                        endOffset: props.player.getSecondsLoaded(),
                                        type: 'audio'
                                    });
                                return props.onChange(value, true)
                            }}
                            onMouseOut={() => {
                                if (toolTip) {
                                    toolTip.style.display = 'none';
                                }
                            }}
                            onMouseMove={(event) => {
                                //Cannot display tooltip under 300 px
                                // @todo fix this if possible
                                if (toolTip && timelineRange) {
                                    if (window.innerHeight >= 300 || props.isMedium) {
                                        const timelineBoundingRect = timelineRange.getBoundingClientRect()
                                        //max input vaut la longueur en pixels de la box + le décalage en pixels en partant du bord gauche de la fenêtre
                                        const maxInput = timelineBoundingRect.width + timelineBoundingRect.left;
                                        //minInput = juste le décalage en px du bord gauche de l'écran
                                        const minInput = timelineBoundingRect.x
                                        //  on veut la valeur du buffer - l'interpolation de la valeurCourante de la souris en px
                                        //  vers une valeur comprise entre 0 et bufferSize rammenée proportionnellement a la taille de la timeline
                                        // toolTip.textContent = "-" + formatTime(bufferSize - (convertValueToRange(event.clientX, minInput, maxInput, props.fragment, bufferSize)));
                                        toolTip.textContent = formatTime(-(bufferSize - convertValueToRange(event.clientX, minInput, maxInput, props.fragment, bufferSize)));
                                        if (props.isMedium) {
                                            const toolTipWidthString = getComputedStyle(toolTip).width;
                                            const toolTipWidthValue = +(toolTipWidthString.split('px')[0])
                                            toolTip.style.left = `${event.clientX - minInput - (toolTipWidthValue / 2)}px`;
                                        } else {
                                            toolTip.style.left = `${event.clientX - minInput}px`;
                                            toolTip.style.bottom = `${timelineBoundingRect.x * 2}px`;
                                        }
                                        toolTip.style.display = 'flex';
                                    } else {
                                        toolTip.style.display = 'none';
                                    }
                                }
                            }}
                    ></Slider>
                    <div id='timeline-tooltip' style={{color: props.buttonColor}}></div>
                    <OnAirBlock className="timeline-container-onAirBlock"
                                previousPlayTime={props.previousPlayTime}
                                fragment={props.fragment}
                                onChange={props.onChange}
                                bufferSize={bufferSize}
                                onAirLabel={props.onAirLabel}
                                secondaryColor={props.secondaryColor}
                                buttonColor={props.buttonColor}
                    />
                </>

            }
        </div>
    );
}

export default function LinearBuffer(props) {
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(0);
    // const [isLoading, setIsLoading] = React.useState(true);
    const progressRef = React.useRef(() => {
    });
    React.useEffect(() => {
        progressRef.current = () => {
            if (props.player?.getCurrentTime() !== undefined) {
                const currentTime = props.player.getCurrentTime();
                const bufferedTime = props.player.getSecondsLoaded();
                const duration = props.player.getDuration();
                if (duration > 0) {
                    const progressValue = (currentTime / duration) * 100;
                    const bufferValue = (bufferedTime / duration) * 100;
                    setProgress(progressValue);
                    setBuffer(bufferValue);
                } else {
                    setProgress(0);
                    setBuffer(0);
                }
            }
        };
    });

    React.useEffect(() => {
        const timer = setInterval(() => {
            progressRef.current();
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, [props.player]);

    function hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    return (
        <Box className='timeline-buffer'>
            <LinearProgress sx={{
                '& .MuiLinearProgress-bar': {
                    backgroundColor: `${props.color} !important`,
                    borderRadius: '100px'
                },
                '& .MuiLinearProgress-dashed': {
                    display: 'none',
                    backgroundImage: `radial-gradient(rgb(${hexToRgb(props.buttonColor)}) 0%, rgb(${hexToRgb(props.buttonColor)}) 16%, transparent 42%)!important`
                },
            }} variant="buffer"
                            value={progress}
                            valueBuffer={buffer}/>
        </Box>
    );
}

export function Image(props) {
    const isDefaultLoading = props.display?.includes('defaultWait');
    const isDefaultGoeRestriction = props.display?.includes('defaultGeoRestriction');
    const isDefaultUnavailable = props.display?.includes('defaultUnavailable');
    const isDefaultThumbnail = props.display?.includes('defaultImage');
    const fade = props.neverPlayed ? '' : 'fadeOut';

    if (isDefaultLoading) {
        props.onLoad();
        return <Spinner color={props.buttonColor}></Spinner>
    } else if (isDefaultGoeRestriction) {
        props.onLoad();
        return <div id="image" className={'default-thumbnail ' + fade}>
            <DefaultGeoRestriction color={props.buttonColor}></DefaultGeoRestriction>
            <span style={{color: props.buttonColor}}>{props.translations.restriction}</span>
        </div>
    } else if (isDefaultUnavailable) {
        props.onLoad();
        return <div id="image" className={'default-thumbnail ' + fade}>
            <DefaultUnavailable color={props.buttonColor}></DefaultUnavailable>
            <span style={{color: props.buttonColor}}>{props.translations.unavailable}</span>
        </div>
    } else if (isDefaultThumbnail) {
        props.onLoad();
        return <div id="image" className={'default-thumbnail large-thumbnail ' + fade}>
            <DefaultThumbnail color={props.buttonColor}></DefaultThumbnail>
        </div>
    } else if (props.display) {
        return <img id="image" src={props.display} alt="defaultImage" onLoad={props.onLoad} className="fadeOut"/>;
    }
}

function Spinner(props) {
    return <div id="image">
        <div className="spinner">
            <svg className="spinner-circle" viewBox="0 0 50 50" id="image">
                <circle
                    style={{stroke: props.color}}
                    className="path"
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                ></circle>
            </svg>
        </div>
    </div>
}

export function Skeleton(props) {
    const skeletonClass = props.className + (props.hidden ? ' animated-skeleton hidden' : ' animated-skeleton');
    return <div className={skeletonClass}></div>;
}

export function ButtonPlayPause(props) {
    return props.playing ?
        <Pause id="pause" onClick={props.onClickPause}
               alt="pause"
               color={props.color}/>
        :
        <Play id="play" onClick={props.onClickPlay}
              alt="play"
              color={props.color}/>;
}

export function ButtonSpeaker(props) {
    return props.muted ?
        <div className="volume-icon-container">
            <SoundOff id="mute" onClick={props.onClick}
                      alt="mute"
                      color={props.color}
                      onMouseEnter={props.onMouseEnter}
                      onMouseLeave={props.onMouseLeave}/>
        </div>
        :
        <div className="volume-icon-container">
            <Sound id="speaker" onClick={props.onClick}
                   alt="speaker"
                   color={props.color}
                   onMouseEnter={props.onMouseEnter}
                   onMouseLeave={props.onMouseLeave}/>
        </div>
}

export function ButtonQuality(props) {
    return props.visible &&
        <Settings
            id="cog"
            alt="cog"
            onClick={() => props.onClick("quality")}
            color={props.color}
        />;
}

export function ButtonQualityOrVolumeContainer(props) {
    return props.visible ?
        <Settings id="cog" alt="cog" onClick={() => props.onClick("quality")}
                  color={props.color}/>
        : <div id="volume-container">
            <Slider type='range' min={0} max={1} step={0.0000001} value={props.volume}
                    defaultValue={props.defaultVolume}
                    id="volume"
                    style={{color: props.color}}
                    onChange={props.onChange}/>
        </div>;
}

export function ButtonHistory(props) {
    return props.visible &&
        <History id="button-history" alt="button-history" onClick={() => props.onClick("history")}
                 color={props.color}/>;
}

export function ButtonShare(props) {
    return props.visible &&
        <Share
            id="share"
            alt="share"
            onClick={() => props.onClick("share")}
            color={props.color}
        />;
}

export function ButtonShareWithTitle(props) {
    let display = <div id="title-container" className="text-fade"><p id="title">{props.title}</p></div>;
    if (props.visibleHistory || props.visibleShare) {
        if (props.visibleHistory) {
            display = <>{display}<ButtonHistory visible={props.visibleHistory} color={props.buttonColor}
                                                onClick={() => props.onClick("history")}/></>
        }
        if (props.visibleShare) {
            display = <>{display}<Share id="share" alt="share" onClick={() => props.onClick("share")}
                                        color={props.buttonColor}/></>
        }
        display = <div id="title-share" className="buttons">
            {display}
        </div>
    }
    return display
}

export function NumberListener(props) {
    // if the number of listeners is >= 1000, format the number in K-listeners with 1 decimal
    const formattedListeners = props.numberListener >= 1000 ? (Math.round(props.numberListener / 100) / 10).toString() + 'K' : props.numberListener?.toString();

    return (formattedListeners && (props.preview || props.numberListener >= props.listenerHold) && props.displayListener && !props.error) &&
        <p id="number-listener">{formattedListeners} <Listeners color={props.color}/></p>;
}

export function OverlayQuality(props) {
    let mainDisplay = "";
    if (props.streams.length > 1) {
        let displayQuality = [];
        for (let i = 0; i < props.streams.length; i++) {
            const stream = props.streams[i];
            const format = stream?.format?.replace(/\./g, '').toUpperCase(); // remove '.' before the stream format

            // If is default url display checked mark
            let selected = props.stream.uuid === stream.uuid ? <Selected className={"option-check"} alt="selected"
                                                                         color={props.buttonColor}/> : "";
            // Add path between quality
            if (i > 0) {
                displayQuality.push(<span key={"path-" + i} className="path"/>);
            }
            let bitrate = stream.format === "hls" ? 'auto' : stream.bitrate + " Kbps";

            displayQuality.push(
                <div key={i} id={"stream" + stream.uuid} className="option-text-container"
                     onClick={() => {
                         let streamQuality = props.streams[i];
                         props.load(streamQuality);
                         props.onClickClose("quality");
                     }}>
                    <div className="option-format">
                        {format}
                        {selected}
                    </div>
                    <div className="option-bitrate">{bitrate}</div>
                </div>
            );
        }

        // Wrap qualities in container
        displayQuality = <div id="option-container">
            {displayQuality}
        </div>

        if (props.addTitle) {
            // Wrap container in new container with title
            displayQuality =
                <div id="option-title-container">
                    <div id="title-quality">{props.translations.quality}</div>
                    {displayQuality}
                </div>;
        }

        // Wrap container in the overlay
        mainDisplay = <div key="quality-overlay" id='quality-overlay'
            // f2 for 0.95 transparence
                           style={{backgroundColor: props.backgroundColor + "f2"}}>
            <div className='close-container'>
                <Close className='close-button' alt="close"
                       onClick={() => props.onClickClose("quality")}
                       color={props.buttonColor}/>
            </div>
            {displayQuality}
        </div>;
    }
    return mainDisplay;
}

export function OverlayShare(props) {
    const [focus, setFocus] = React.useState('url');
    const [copiedSuccessfully, setCopiedSuccessfully] = React.useState(false);
    const integrationCode = "<iframe style='height:" + window.innerHeight + "px;width=" + window.innerWidth + "px;' src='" + window.location.href + "'>";
    const inputValue = focus === 'url' ? window.location.href : integrationCode;
    const successMessage = `${focus === 'url' ? props.translations.urlCopy : props.translations.codeCopy} ${String.fromCodePoint(0xD83D, 0xDC4D)}`;

    const xUrl = new URL('https://x.com/intent/post', window.origin);

    const facebookUrl = new URL('https://www.facebook.com/sharer/sharer.php', window.origin);

    if (props.facebook) {
        facebookUrl.searchParams.set('u', props.facebook);
    }

    if (props.twitter) {
        xUrl.searchParams.set('url', props.twitter);
    }

    if (props.twitterAccount) {
        xUrl.searchParams.set('via', props.twitterAccount);
    }

    if (props.twitterHashtags) {
        xUrl.searchParams.set('hashtags', props.twitterHashtags);
    }

    const copyToClipBoard = () => {
        try {
            const inputElement = document.getElementById('share-input');

            if (inputElement) {
                inputElement.select();
                inputElement.setSelectionRange(0, inputElement.value.length);
                const res = document.execCommand('copy');

                // if the copy is successful, display the success message during 2s
                if (res) {
                    setCopiedSuccessfully(true);

                    setTimeout(() => setCopiedSuccessfully(false), 2000);
                }

                inputElement.blur();
            }
        } catch (e) {
            console.error('impossible to copy to clipboard: permission denied');
        }
    }

    let shareUrl =
        <>
            {props.embedEnable &&
                <button id="share-url-button" className={focus === 'url' ? 'focused' : ''} onClick={() => setFocus('url')}>
                    <Link color={props.buttonColor}></Link>
                </button>
            }
        </>;

    let shareIframe =
        <>
            {props.embedEnable &&
                <button id="share-iframe-button" className={focus === 'integration' ? 'focused' : ''} onClick={() => setFocus('integration')}>
                    <Integration color={props.buttonColor}></Integration>
                </button>
            }
        </>;

    let shareFacebook =
        <>
            { props.facebook &&
                <a id="share-facebook-button" href={facebookUrl.href} target="blank_">
                    <Facebook color={props.buttonColor}></Facebook>
                </a>
            }
        </>


    let shareTwitter =
    <>
        { props.twitter &&
            <a id="share-x-button" href={xUrl.href} target="blank_">
                <X color={props.buttonColor}></X>
            </a>
        }
    </>


    return <>
        {(props.embedEnable || props.facebook || props.twitter) &&
            <div id='share-overlay' style={{backgroundColor: props.backgroundColor + "f2"}}>
                <div className='close-container'>
                    <Close className='close-button' alt="close"
                           onClick={() => props.onClickClose("share")}
                           color={props.buttonColor}/>
                </div>
                <div id="share-container">
                    <div id="social-media-buttons">{shareUrl}{shareIframe}{shareTwitter}{shareFacebook}</div>
                    {focus && <p className="share-label">{ focus === 'url' ? props.translations.url : props.translations.integration }</p>}
                    {focus &&
                        <div className="share-input">
                            <input id="share-input" readOnly={true} value={copiedSuccessfully ? successMessage : inputValue}/>
                            { !copiedSuccessfully && <Copy color={props.backgroundColor} onClick={() => copyToClipBoard()}></Copy> }
                        </div>
                    }
                </div>
            </div>
        }
    </>;
}

export function OverlayPlay(props) {
    return <div id="circle-play" className={props.neverPlayed ? 'never-played' : (props.playing ? 'played' : 'paused')}>
        <span id="play-image" className="cursor-pointer front-index"
              onClick={props.playing ? props.onClickPause : props.onClickPlay}
              style={{backgroundColor: props.backgroundColor}}/>
        {props.playing ? <Pause color={props.buttonColor}/> : <Play color={props.buttonColor}/>}
    </div>;
}

export function ArrowButton(props) {
    if (props.stations && props.stations.length > 0) {
        return <div id='player-arrow' className={props.isExtend ? 'open' : 'close'}
                    onClick={props.onClick}
            // f2 for 0.95 transparence
                    style={{backgroundColor: props.backgroundColor + "f2"}}>
            <Arrow alt="arrow" color={props.buttonColor}/>
        </div>;
    }
}

export function Extend(props) {

    if (props.stations && props.stations.length > 0) {
        let stationsRender = [];

        for (let i = 0; i < props.stations.length; i++) {
            let selected = "";
            let borderColor = {};
            if (props.stations[i].streams[0].uuid === props.streams[0].uuid) {
                borderColor = {borderColor: props.buttonColor};
                selected = "selected";
            }
            let station = props.stations[i];
            stationsRender.push(<div key={station.id} className='station-thumbnail'>
                <img src={station.thumbnail} alt={station.playername} className={selected}
                     style={borderColor}/>
                <div className='play-station-overlay' onClick={() => props.onClick(i)}>
                     <span id="play-station-image" className="cursor-pointer front-index"
                         // f2 for 0.95 transparence
                           style={{backgroundColor: props.backgroundColor}}/>
                    <Play color={props.buttonColor}/>
                </div>
            </div>);
        }
        return <div id='player-extended' className={props.isExtend ? 'open' : 'close'}
                             style={{backgroundColor: props.backgroundColor + "f2"}}>
            {stationsRender}
        </div>;
    }

}

function startMarqueeScroll(element, marqueeClass) {
    if (element.scrollWidth > element.offsetWidth) {
        element.style.width = "fit-content";
        element.classList.add(marqueeClass);
    }
}

function stopMarqueeScroll(element, marqueeClass) {
    element.classList.remove(marqueeClass);
    element.style.removeProperty("width");
}


/**
 *
 *
 * Timeline
 *
 */

export function HistorySkeletonItem(props) {
    return <div className="track-row history-row-skeleton">
        {props.showTimecode && <Skeleton className="time skeleton"></Skeleton>}
        <Skeleton className="cover skeleton"></Skeleton>
        <div className="artist-title">
            <Skeleton className="artist skeleton"></Skeleton>
            <Skeleton className="title skeleton"></Skeleton>
        </div>
    </div>
}

export function HistorySkeleton(props) {
    let timelineRender = [];

    for (let i = props.skeletonSize - 1; i >= 0; i--) {
        timelineRender.push(<HistorySkeletonItem showTimecode={props.showTimecode} key={i}></HistorySkeletonItem>);
    }

    return timelineRender
}

export function HistoryExtended(props) {
    const [loading, setLoading] = React.useState(false); // boolean indicating that the track list is being updated
    const [trackInserting, setTrackInserting] = React.useState(false); // boolean indicating that a track is being inserted at the top with a slide effect
    const [filteredTracks, setFilteredTracks] = React.useState([]); // filtered tracks that will be displayed in the history (used to handle transitions when new tracks appear)
    const [tracks, setTracks] = React.useState([]); // tracks displayed in the history
    const [latestPlayTime, setLatestPlayTime] = React.useState(null); // timestamp of the latest playtime of the buffer (in seconds)
    const timer = React.useRef(null); // reference of the track list update timeout (used to clear the previous timeouts if the timeline is updated)

    // compare if 2 track lists are different
    const trackListChanged = (first, second) => {
        return first.map((t) => t.title).join() !== second.map((t) => t.title).join();
    }

    // compare if 2 tracks are equal
    const tracksEqual = (first, second) => {
        return Boolean(first) && Boolean(second) && Object.keys(first).every((key) => first[key] === second[key]);
    }

    // this useEffect is used to handle timeline updates and filter the tracks to display in the timeline
    // it also corrects the delays between timeline update and the track start timestamp so that the timeline follow the currently playing track
    React.useEffect(() => {
        const liveOffset = numberFragmentBeforeLive * (props.fragment ?? 0);
        const currentTime = props.currentTime || 0;
        const playTime = Date.now() / 1000 + (props.isDirectControl ? -liveOffset : currentTime); // timestamp of the latest playtime depending on the buffer mode (in seconds)
        const filteredTimeline = props.timeline?.filter((track) => track.author || track.title); // filter tracks that have at least an artist or a title

        if (Boolean(filteredTimeline?.length)) {
            const lastTimelineTrack = filteredTimeline.find((track) => track.date + liveOffset > playTime); // find the first track played before the latest PlayTime if it exists

            // if the last track of the timeline (track playing in live) appears before the start date of the track
            // it must be filtered from the timeline to appear when the track starts playing
            // then we wait until the track start playing to make it appear in the timeline
            if (lastTimelineTrack) {
                const apparitionDelay = lastTimelineTrack.date + liveOffset - playTime + 1; // delay between the next track start timestamp and the last play time (in seconds)

                // cleat the previous track update timeouts
                clearTimeout(timer.current);

                // start a timeout to update the track list when the new track start
                timer.current = setTimeout(() => {
                    setFilteredTracks(filteredTimeline.filter((track) => playTime + apparitionDelay >= track.date + liveOffset));
                }, apparitionDelay * 1000);
            }

            if (!lastTimelineTrack || !Boolean(filteredTracks?.length) || playTime !== latestPlayTime) {
                // else simply update the track list with the tracks already played
                setFilteredTracks(filteredTimeline.filter((track) => playTime >= track.date + liveOffset));
            }

            setLatestPlayTime(playTime);
        }

        // when the timeline is loading, skip filtering and clear all timeouts
        if (!props.timelineLoaded && props.timeline?.length === 0) {
            setFilteredTracks(props.timeline);
            clearTimeout(timer.current);
        }
    }, [props.timeline, props.currentTime]);

    // set timeout to delay track render with a transition
    React.useEffect(() => {
        // if the track list has changed, delay the re-render of the history
        // if the track list is empty, render immediately
        if (trackListChanged(filteredTracks, tracks)) {
            const newTrackAddedToTimeline = tracksEqual(tracks[tracks.length - 1], filteredTracks[filteredTracks.length - 2]);

            // when a single track appear in the list, use slide transition instead of fade
            if (newTrackAddedToTimeline) {
                setLoading(true);
                setTrackInserting(true);
                setTracks(filteredTracks);
            } else {
                // else fade the whole history
                setLoading(true);
                setTimeout(() => {
                    if (loading) {
                        setTracks(filteredTracks);
                        setLoading(false);
                    }
                }, 1000);
            }
        }

        setTimeout(() => {
            if (loading) {
                setLoading(false);
                setTrackInserting(false);
            }
        }, 2000);
    }, [loading, filteredTracks]);

    const showSkeleton = !tracks || tracks.length === 0;

    const timelineRender = [];

    const currentTime = props.currentTime || 0;
    const bufferSize = Math.min(props.bufferSize ?? props.fragment * props.playlist, props.fragment * props.playlist); // keep the min value between the real player buffer and the hls playlist size
    const isBigBufferHls = props.streamFormat === 'hls' && props.isHlsBuffered && props.fragment && props.playlist;
    const currentPlayTime = ((Date.now() + (currentTime * 1000)) / 1000);
    const currentTrack = props.timeline.find((track, index) => track.title === props.currentTrack && currentPlayTime >= track.date && (!tracks[index + 1] || currentPlayTime <= tracks[index + 1].date));

    let timelineLength = tracks.length;
    for (let i = timelineLength - 1; i >= 0 && timelineLength - props.historyHold <= i; i--) {
        let track = tracks[i];
        const isDefaultThumbnail = !track.cover || track.cover.includes('defaultImage');
        const timelinePosition = bufferSize - ((Date.now() / 1000) - track.date) + props.fragment * numberFragmentBeforeLive; // position of the track in the buffer
        const timeShiftAvailable = props.isDirectControl && props.allowTimeshift && props.streamFormat === 'hls' && props.fragment && props.playlist; // the timeshift is available if the stream is hls (with playlist and fragments) and if the option is activated
        const isTimeShift = timelinePosition >= 0 && timeShiftAvailable; // the track can be clicked if the timeshift is available and if the track is in the buffer
        const isDirectControlLive = currentTime >= numberFragmentBeforeLive * props.fragment * -1;
        const isFirstTrack = i === timelineLength - 1;
        const showLiveSpectrum = (props.isSingleHistory && isFirstTrack) || props.playing && (((!props.isDirectControl || isDirectControlLive) && isFirstTrack) || props.isDirectControl && !isDirectControlLive && currentTrack?.date === track.date);
        const trackTime = new Date(track.date * 1000 + (isBigBufferHls ? bufferSize * 1000 : 0));
        let rowClass = 'track-row';

        if (isTimeShift) {
            rowClass += ' cursor-pointer';
        }

        if (i === timelineLength - 1 && trackInserting) {
            rowClass += ' row-inserting';
        }

        // history-marquee-short is for the first song in history who is shorter than another du to Live tag
        let marqueeClass = i === timelineLength - 1 ? 'history-marquee-short' : "history-marquee";
        marqueeClass = (props.type === 'extended' ? 'extend-' : '') + marqueeClass
        if (track.title || track.author) {
            timelineRender.push(<div className={rowClass} key={i} onClick={() => {
                    if (isTimeShift) {
                        props.onClick(timelinePosition, true);
                    }
                }}>
                    {props.showTimecode &&
                        <div className="time" style={{color: isTimeShift ? props.timeColor : props.textColor}}>
                            {trackTime.toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit"
                            })}
                        </div>}
                    {!isDefaultThumbnail && <img className="cover" src={track.cover}/>}
                    {isDefaultThumbnail && <div className="cover default-thumbnail large-thumbnail"
                                                style={{background: adjustColor(props.backgroundColor, -0.05)}}>
                        <DefaultThumbnail color={props.textColor}></DefaultThumbnail>
                    </div>}
                    <div className="artist-title text-fade">
                        <div className="artist" id={props.type + "_track_artist_" + i}
                             onMouseEnter={(event) => startMarqueeScroll(event.target, marqueeClass)}
                             onMouseLeave={(event) => stopMarqueeScroll(event.target, marqueeClass)}
                             style={{color: getContrastingColor(props.textColor, props.backgroundColor)}}>{track.author}</div>
                        <div className="title" id={props.type + "_track_title_" + i}
                             onMouseEnter={(event) => startMarqueeScroll(event.target, marqueeClass)}
                             onMouseLeave={(event) => stopMarqueeScroll(event.target, marqueeClass)}
                             style={{color: props.textColor}}>{track.title}</div>
                    </div>
                    <AnimatedSpectrum color={props.timeColor} visible={showLiveSpectrum}></AnimatedSpectrum>
                </div>
            )
        }
    }

    const skeleton = <HistorySkeleton skeletonSize={props.historyHold} showTimecode={props.showTimecode}
                                      key={'history-skeleton'}></HistorySkeleton>

    return <div className={(props.historyDisplay === 'split' ? 'split-history-wrapper' : 'history-wrapper') + (showSkeleton ? ' loading' : '')}>
        <div className={(props.historyDisplay === 'split' ? 'split-history' : 'history') + (props.historyDisplay === 'under' ? ' history-extended' : '')}>
            <React.Fragment key={'top-fragment'}>
                <div id="top-shadow" key='top-shadow'
                     style={{background: "linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, " + props.backgroundColor + " 100%)"}}></div>
                <div id="fade-shadow" className={loading && !trackInserting ? 'visible' : 'hidden'}
                     style={{background: props.backgroundColor}}></div>
            </React.Fragment>

            {showSkeleton ? skeleton : timelineRender}

            <React.Fragment key={'bottom-fragment'}>
                <div id="bottom-shadow" key={'bottom-shadow'}
                     style={{background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, " + props.backgroundColor + " 100%)"}}></div>
            </React.Fragment>
        </div>
    </div>;
}

export function OverlayHistory(props) {
    return props.visible && <div id='history-overlay' style={{backgroundColor: props.backgroundColor + "f2"}}>
        <div className='close-container close-history'>
            <Close className='close-button' alt="close"
                   onClick={() => props.onClickClose("history")}
                   color={props.buttonColor}/>
        </div>
        <HistoryExtended timeline={props.timeline} timeColor={props.timeColor} bufferSize={props.bufferSize}
                         textColor={props.buttonColor} isDirectControl={props.isDirectControl}
                         currentTrack={props.currentTrack} streamFormat={props.streamFormat}
                         backgroundColor={props.backgroundColor} historyHold={props.historyHold}
                         currentTime={props.currentTime} isHlsBuffered={props.isHlsBuffered}
                         playing={props.playing} historyDisplay="overlay" timelineLoaded={props.timelineLoaded}
                         fragment={props.fragment} playlist={props.playlist} preview={props.preview}
                         onClick={props.onClick} type={props.type} allowTimeshift={props.allowTimeshift}
                         showTimecode={props.showTimecode}/>
    </div>;
}

export function AnimatedSpectrum(props) {
    let spectrumContent = [];
    const spectrumClass = 'animated-spectrum ' + (props.visible ? 'visible' : 'hidden');

    for (let i = 0; i < 4; i++) {
        spectrumContent.push(
            <div className="animated-spectrum-item" key={'animated-spectrum-' + i} style={{background: props.color}}></div>
        );
    }

    return <div className={spectrumClass}>
        {spectrumContent}
    </div>
}

/**
 *
 * Common React Player
 *
 */


export function CustomReactPlayer(props) {
    return <ReactPlayer
        id="react-player"
        ref={props.myRef}
        className='react-player'
        url={props.url}
        playing={props.playing}
        light={props.light}
        playbackRate={props.playbackRate}
        volume={props.volume}
        muted={props.muted}
        height={0}
        width={0}
        onReady={props.onReady}
        onPlay={props.onPlay}
        onProgress={e => props.onProgress(e)}
        onError={e => {
            // real error
            if (e.type && !props.neverPlayed && props.playing) {
                props.setPlayerInError(props.unavailableUrl);
            } else {
                // not real error
                props.onReady();
            }
        }}
        config={{...hlsConfigFromPlayerProps(props)}}
    />
}

function hlsConfigFromPlayerProps(props) {
    if (!props.isDirectControl && props.isHlsBuffered) {
        return {
            file: {
                attributes: {
                    crossOrigin: "anonymous"
                },
                hlsOptions: {
                    // Taille du buffer déjà lu à garder en cache (en seconde)
                    // Taille maximum du buffer pas encore lu à garder en cache (en seconde)
                    frontBufferFlushThreshold: Infinity,
                    enableWorker: true,
                    lowLatencyMode: true,
                    backBufferLength: 0,
                    maxMaxBufferLength: Infinity,
                    maxBufferLength: Infinity,
                    maxBufferSize: Infinity,
                    // Nombre de seconde de décalage avec le live (en seconde)
                    liveSyncDuration: props.fragment * numberFragmentBeforeLive,
                    startPosition: 0
                }
            }
        }
    }
    return {
        file: {
            attributes: {
                crossOrigin: "anonymous"
            },
            hlsOptions: {
                // Taille du buffer déjà lu à garder en cache (en seconde)
                backBufferLength: 0,
                // Taille maximum du buffer pas encore lu à garder en cache (en seconde)
                maxMaxBufferLength: props.playlist * (props.fragment),
                // Nombre de seconde de décalage avec le live (en seconde)
                liveSyncDuration: props.fragment * numberFragmentBeforeLive,
                startPosition: 0
            }
        }
    };
}
